<template>
  <div>
    <!--Banner-->
    <div class="uk-cover-container">
      <BannerComponent :banner-url="bannerUrl" :title="title"/>
    </div>

    <div class="uk-container">

      <!--Description-->
      <PropertySectionOne :description="'nilaveli.para_1'|translate"/>

      <!--Slider-->
      <PropertySectionTwo :slide-items="slideItems"/>

      <!--Map-->
      <PropertySectionThree
        :moto="title"
        :description="'nilaveli.para_2'|translate"
        :embedded-map-url="embeddedMapUrl"
      />

      <!--Features-->
      <PropertySectionSix
        :description="'nilaveli.features.para'|translate"
        :features="features"
      />

      <!--Thumbnav-->
      <PropertySectionFour :slide-items="thumbNavItems"/>

      <!-- Testimonials -->
      <PropertyTestimonials :items="testimonials"/>

      <!--Packages-->
      <PropertySectionFive :packages="packages"/>

    </div>

  </div>

</template>

<script>
import BannerComponent from '../components/BannerComponent'
import PropertySectionOne from '../components/properties/PropertySectionOne'
import PropertySectionTwo from '../components/properties/PropertySectionTwo'
import PropertySectionThree from '../components/properties/PropertySectionThree'
import PropertySectionFour from '../components/properties/PropertySectionFour'
import PropertySectionFive from '../components/properties/PropertySectionFive'
import PropertySectionSix from '../components/properties/PropertySectionSix'
import store from '../store'
import PropertyTestimonials from '../components/properties/PropertyTestimonials'

export default {
  name: 'PropertyNilaveli',
  components: {
    PropertyTestimonials,
    BannerComponent,
    PropertySectionOne,
    PropertySectionTwo,
    PropertySectionThree,
    PropertySectionFour,
    PropertySectionFive,
    PropertySectionSix
  },
  data: function () {
    return {
      propertyId: 1,
      title: store.state.property.nilaveli.location,
      bannerUrl: store.state.property.nilaveli.bannerUrl,
      slideItems: store.state.property.nilaveli.slideItems,
      embeddedMapUrl: store.state.property.nilaveli.embeddedMapUrl,
      thumbNavItems: store.state.property.nilaveli.thumbNavItems,
      packages: store.state.property.nilaveli.packages,
      features: store.state.property.nilaveli.features,
      testimonials: store.state.property.nilaveli.testimonials
    }
  },
  mounted () {
    this.fetchPriceList()
    this.fetchDeals()
    this.fetchFoods()
  },
  methods: {
    fetchPriceList () {
      this.$store.dispatch('property/fetchPropertyPriceList', { propertyId: this.propertyId })
    },
    fetchDeals () {
      this.$store.dispatch('property/fetchPropertyDeals', { propertyId: this.propertyId })
    },
    fetchFoods () {
      this.$store.dispatch('property/fetchPropertyFoods', { propertyId: this.propertyId })
    }
  }
}
</script>

<style scoped>

</style>
